export enum ESugNirsham
{
  amit = 1,
  nilve = 2,
  yeled = 3,
  tinok = 4
}